import { EjendomsfaktorDefinitionValgmulighedDto } from "./ejendomsfaktor-definition-valgmulighed.dto";

export class EjendomsfaktorDefinitionDto {
    public datatype: number;
    public decimaler: number;
    public enhed: string;
    public id: number;
    public maske: string;
    public maxVaerdi: number;
    public minVaerdi: number;
    public navn: string;
    public readonly: boolean;
    public valgmuligheder: EjendomsfaktorDefinitionValgmulighedDto[];
}
